export const getInteger = (number: string) => parseInt(number.replace(/[^\d.]/g, ''), 10);
